import { ComponentBase } from '../../../component-base';
import { IMouseDown, IMouseMove, IMouseRelease } from '../Interfaces';
import { Injectable } from '@angular/core';
import { ConnectionPoint, PolyLine, PolyLineRecord, Arc } from '../object3D';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { common } from '../common';

declare let THREE: any;

@Injectable()
export class MovePolylineNodes extends ComponentBase
  implements IMouseDown, IMouseMove, IMouseRelease {
  private selectedObject?;
  private raycaster = new THREE.Raycaster(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, -1, 0));
  private record?: PolyLineRecord;
  private records: Array<PolyLineRecord>;
  private connectionPoint: ConnectionPoint;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(obj => {
      if (obj) {
        if (obj[0] instanceof PolyLine || obj[0] instanceof Arc) {
          this.changePointsVisibility(false);
          this.selectedObject = obj[0];
          this.changePointsVisibility(true);
        } else {
          this.changePointsVisibility(false);
          this.selectedObject = null;
        }
      } else {
        this.selectedObject = null;
      }
    });
  }

  private changePointsVisibility(visible: boolean) {
    if (this.selectedObject) {
      this.selectedObject.children
        .filter(ch => ch instanceof ConnectionPoint)
        .forEach(p => (p.visible = visible));
    }
  }

  mouseDown(e: MouseEvent) {
    const { selectedObject } = this;
    if (selectedObject) {
      if (selectedObject instanceof PolyLine) {
        this.records = selectedObject.objectsList();
        const connectionPoints = this.records.map(p => p.currentPoint);
        const position = this.positionCalculator.calculate(e);
        this.raycaster.ray.origin.copy(position).setY(common.raycastAtY);
        const intersection = this.raycaster.intersectObjects(connectionPoints) as Array<any>;
        if (intersection.length !== 0) {
          const connectionPoint = intersection[0].object as ConnectionPoint;
          this.record = this.records.find(r => r.currentPoint === connectionPoint);
          return true;
        }
      } else if (selectedObject instanceof Arc) {
        const position = this.positionCalculator.calculate(e);
        const connectionPoints = selectedObject.children.filter(
          ch => ch instanceof ConnectionPoint
        );
        this.raycaster.ray.origin.copy(position).setY(common.raycastAtY);
        const intersection = this.raycaster.intersectObjects(connectionPoints) as Array<any>;
        if (intersection.length !== 0) {
          this.connectionPoint = intersection[0].object as ConnectionPoint;
          return true;
        }
      }
    }
    return false;
  }

  mouseMove(e: MouseEvent) {
    if (this.record) {
      const { currentLine, prevLine, currentPoint } = this.record;
      const positionOffset = this.selectedObject.position.clone().setY(0);
      const currentPointPosition = this.positionCalculator.calculate(e).setY(0).sub(positionOffset);
      const records = this.records;
      if (!prevLine) {
        const nextPointPosition = records[records.indexOf(this.record) + 1].currentPoint.position;
        currentLine.update(currentPointPosition, nextPointPosition);
        currentLine.position.copy(currentPointPosition);
        currentPoint.position.copy(currentPointPosition);
      } else if (prevLine && currentLine) {
        const nextPointPosition = records[records.indexOf(this.record) + 1].currentPoint.position;
        const prevPointPosition = records[records.indexOf(this.record) - 1].currentPoint.position;
        currentPoint.position.copy(currentPointPosition);
        currentLine.position.copy(currentPointPosition);
        currentLine.update(currentPointPosition, nextPointPosition);
        prevLine.update(prevPointPosition, currentPointPosition);
      } else if (!currentLine) {
        const prevPointPosition = records[records.indexOf(this.record) - 1].currentPoint.position;
        currentPoint.position.copy(currentPointPosition);
        prevLine.update(prevPointPosition, currentPointPosition);
      }
      return true;
    } else if (this.connectionPoint) {
      const positionOffset = this.selectedObject.position.clone().setY(0);
      const currentPointPosition = this.positionCalculator.calculate(e).setY(0).sub(positionOffset);
      this.connectionPoint.position.copy(currentPointPosition);
      this.selectedObject.update();
      return true;
    }
    return false;
  }

  mouseUp(e: MouseEvent): boolean {
    if (this.record) {
      this.record = null;
      this.records = null;
      return true;
    }
    if (this.connectionPoint) {
      this.connectionPoint = null;
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MovePolylineNodes.ts